import React from "react";
import { Settings, Cpu, RefreshCw, UserCheck } from "lucide-react";

export const HowItWorks = () => {
  const steps = [
    {
      icon: Settings,
      step: "1",
      title: "On installe votre système",
      description: "Configuration complète en 48h. Vous n'avez rien à faire.",
      time: "48h",
    },
    {
      icon: Cpu,
      step: "2",
      title: "L'IA capte vos leads",
      description: "Appels, WhatsApp, formulaires... tout est centralisé et qualifié.",
      time: "24/7",
    },
    {
      icon: RefreshCw,
      step: "3",
      title: "Elle relance automatiquement",
      description: "SMS, WhatsApp, emails. Vos devis sont suivis jusqu'à la signature.",
      time: "Auto",
    },
    {
      icon: UserCheck,
      step: "4",
      title: "Vous recevez les clients chauds",
      description: "Vous ne traitez que les demandes prêtes à signer. Fini le tri.",
      time: "Focus",
    },
  ];

  return (
    <section id="how-it-works" className="py-14 lg:py-28 blueprint-bg">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <p className="section-label text-primary mb-4">Processus</p>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-black text-slate-900 mb-6 tracking-tight">
            Comment ça marche{" "}
            <span className="text-accent">concrètement ?</span>
          </h2>
          <p className="text-lg text-slate-600 max-w-2xl mx-auto">
            Un système hybride, scalable, qui travaille pour vous pendant que vous êtes sur le terrain.
          </p>
        </div>

        {/* Steps Grid */}
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6 max-w-6xl mx-auto">
          {steps.map((item, index) => {
            const Icon = item.icon;
            return (
              <div
                key={item.step}
                className="bg-white border-2 border-slate-200 rounded-md p-6 relative hover:border-primary/50 transition-all"
                style={{boxShadow: '4px 4px 0px rgba(30, 90, 158, 0.1)'}}
                data-testid={`how-it-works-${index}`}
              >
                {/* Step Number Badge */}
                <div className="absolute -top-3 -left-3 w-8 h-8 rounded-md bg-accent text-white flex items-center justify-center text-sm font-black">
                  {item.step}
                </div>
                
                <div className="w-12 h-12 rounded-md bg-primary/10 flex items-center justify-center mb-4 mt-2">
                  <Icon className="w-6 h-6 text-primary" />
                </div>
                
                <div className="inline-block bg-slate-100 text-slate-600 text-xs font-bold px-2 py-1 rounded mb-3">
                  {item.time}
                </div>
                
                <h3 className="text-lg font-bold text-slate-900 mb-2">
                  {item.title}
                </h3>
                <p className="text-slate-600 text-sm leading-relaxed">
                  {item.description}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;
